import { useEffect } from "react";
import Row from "./row";
import { useSpring } from "react-spring";
import * as Styled from "./Table.style";

const TableSummary = (
  { label, current, max, warning, resetWarning, backgroundColor },
) => {
  const [style, api] = useSpring(() => ({
    from: { fontSize: "10px" },
  }));

  useEffect(() => {
    if (warning) {
      api.start({
        to: [{ fontSize: "20px" }, { fontSize: "10px" }],
      });
      resetWarning();
    }
  }, [api, resetWarning, warning]);

  return (
    <Styled.TableSummary backgroundColor={backgroundColor}>
      {`${label}`}
      {current || max
        ? (
          <Styled.TableSummaryValues style={style}>
            {`${current}/${max}`}
          </Styled.TableSummaryValues>
        )
        : null}
    </Styled.TableSummary>
  );
};

const Table = ({
  data,
  summaryLabel,
  summaryTotal,
  summaryMax,
  summaryTotalWarning,
  resetWarning,
  // Defaults to the page background via the theme; pass a value only to pin it to something else.
  backgroundColor,
}) => {
  return (
    <div>
      <Styled.Table backgroundColor={backgroundColor}>
        {data.map((entry) => {
          return <Row key={entry.label} {...entry} />;
        })}
        <TableSummary
          label={summaryLabel}
          current={summaryTotal}
          max={summaryMax}
          warning={summaryTotalWarning}
          resetWarning={resetWarning}
          backgroundColor={backgroundColor}
        />
      </Styled.Table>
    </div>
  );
};

export default Table;
